import React from "react";
import { IonCard, IonLabel, IonCardHeader, IonCardTitle } from "@ionic/react";
import { useIntl } from "react-intl";

const Notes = (props) => {
  const { items } = props;
  const intl = useIntl();

  return items && items[0] ? (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.notes",
          })}
        </IonCardTitle>
      </IonCardHeader>
      <div
        style={{
          padding: "8px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IonLabel>
          {intl.formatMessage({
            id: "app.mobile.personal_file_note",
          })}
        </IonLabel>
        <IonLabel color="medium">{items[0].comment}</IonLabel>
      </div>
    </IonCard>
  ) : null;
};

export default Notes;
